if (document.getElementById('js-product-slider')) {

  const buttonSlider = document.getElementById("js-product-slider-buttons")

  const buttonSliderFlkty = new Flickity(buttonSlider, {
    cellAlign: 'left',
    contain: true,
    imageLoaded: true,
    lazyLoad: true,
    wrapAround: true,
    draggable: true,
    pageDots: false,
    groupCells: 4
  })

  const sliderButtons = document.querySelectorAll(`.js-open-slider`)
  sliderButtons.forEach((item) => {
    item.addEventListener('click', (event) => {
      const carousel = document.getElementById('js-product-slider')

      const productSliderFlkty = new Flickity(carousel, {
        cellAlign: 'left',
        contain: true,
        imageLoaded: true,
        lazyLoad: true,
        wrapAround: true,
        draggable: true,
      })

      productSliderFlkty.select(parseInt(item.getAttribute('data-slide')))

      setTimeout(() => {
        carousel.focus()
      }, 100)
    })
  })
}

const productRelatedSlider = document.querySelectorAll(
  '.js-product-related-slider'
)
if (productRelatedSlider) {
  productRelatedSlider.forEach((slider) => {
    new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      groupCells: true,
      pageDots: false,
      imageLoaded: true,
      lazyLoad: true,
      draggable: true,
    })
  })
}
